export const STORAGE_SESSION_KEY = 'ws_crm_session';
export const STORAGE_REFRESH_KEY = 'ws_crm_refresh';
